// extracted by mini-css-extract-plugin
export default {"credStatus":"statusCell_credStatus__4Zc0B","selectable":"statusCell_selectable__ajTGj"};